import { Box, ColorOptions, IconNew, ModBox, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { memo, useCallback } from 'react'
import { Routes } from '../../../../nav/routes'
import { Colors } from '../../../../util/util'
import { styles } from './styles'

const NotAvailableConfiguration = memo(() => {
  const { navigate } = useNavigation()

  const onConfigurePress = useCallback(() => {
    navigate(Routes.SETTLEMENTS_REPORTING)
  }, [navigate])

  return (
    <Box {...styles.container}>
      <ModBox {...styles.iconContainer}>
        <IconNew id={'BILL'} size={60} color={Colors.REPORT_PRIMARY as ColorOptions} />
      </ModBox>
      <TextNew {...styles.titleText}>{'Report Configuration not available'}</TextNew>
      <ModBox {...styles.subContainer}>
        <TextNew {...styles.subTitleText}>
          {
            'Dear Merchant, you haven’t configured any reports yet. Configure your report here. you can configure one or more as per your needs.'
          }
        </TextNew>
      </ModBox>
      <ModBox {...styles.addReportButton} onPress={onConfigurePress} testID="configure-now">
        <TextNew fontFamily="jiotype-medium" color="WHITE" fontSize={14}>
          {'Configure Now…'}
        </TextNew>
      </ModBox>
    </Box>
  )
})

export default NotAvailableConfiguration
